export interface WizardIntroScreenProps {
  customerServicePhone: string;
  onBegin: () => void;
}

export function WizardIntroScreen({ customerServicePhone, onBegin }: WizardIntroScreenProps) {
  return (
    <div className="panel">
      <div className="panel-body" style={{ textAlign: 'center', padding: '48px 48px' }}>
        <h4 className="mb-3">Home Delivery Sign-Up</h4>
        <p className="mb-4">
          Here you can sign up for our home delivery services. To get started, click the "Sign Up For Home Delivery" button and then select the member you want to enroll. Then, tell us about their allergies, health conditions, and current medications. You will click the "Continue" button and can return to a previous section by using the "Back" button.
        </p>
        <p className="mb-4">
          If you have any questions, please call Home Delivery Customer Service at{' '}
          {customerServicePhone}.
        </p>
        <div style={{ marginTop: '50px' }}>
          <button type="button" className="btn btn-primary" onClick={onBegin}>
            Sign Up For Home Delivery
          </button>
        </div>
      </div>
    </div>
  );
}
